export default __webpack_public_path__ + "static/media/meterreading-6.e9cd19c5.png";